import { CART_RESET_STATE } from 'constants/reduxActions';

import { fetchCheckoutData } from 'actions/checkout/purchase';

export function changeItemQuantity(info, mafiaEndpoints) {
  return function(dispatch) {
    const params = {
      advanceOnSuccess: false,
      quantityUpdate: info,
      showFullPageSpinner: false,
      includeShipmentOptions: info.quantity === '0'
    };
    dispatch({ type: CART_RESET_STATE });
    return dispatch(fetchCheckoutData(params, mafiaEndpoints));
  };
}
